export default "__VITE_ASSET__MnSuel6S__"